// extracted by mini-css-extract-plugin
export default {"wrapper":"Step_wrapper__C-vJi","number":"Step_number__ShvpY","label":"Step_label__TMsc9","active":"Step_active__xzAQh"};